module.exports = __webpack_public_path__ + "static/media/vapour-img3.002dd30a.jpg";